var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5l-3-3c-1-1-3-2.455-3-4.25a3.25 3.25 0 016-1.733 3.25 3.25 0 016 1.733c0 .28-.024.526-.07.75",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#subscribe_svg__clip0_6976_472275)",
    stroke: "#3F465C",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.094 10.5h4.812M11.5 12.906V8.094"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "subscribe_svg__clip0_6976_472275"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 7)",
    d: "M0 0h7v7H0z"
  })))));
}
export default __webpack_public_path__ + "static/subscribe.a0475eff.svg";
export { SvgSubscribe as ReactComponent };